import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import TableComponent from "./../../components/TableComponent";
import SearchBox from "./../../components/SearchComponent";
import { formatDate, formatListItems, isValidObject, reverseDateFormat } from "./../../../utils";
import { appApis, headerColumn } from "./../../../constants";
import { getInstallerInventory } from "../../../actions/inventory";
import SearchableDropdown from "../../../Common/SearchDropdown";
import { getInstallers } from "../../../actions/installer";
import ReasonModal from "../../components/ReasonModal";
import { useApiRequest } from "../../../hooks/useApiRequest";
import InventoryDetails from "./InventoryDetails";

const InstallerInventory = () => {
    const [state, setState] = useState({
        lists: [],
        loading: false,
        selected: null,
        search: "",
        installer: "",
        type: "",
        installerList: [],
        current: 1,
        total: 1,
        discardData: null
    });
    const { request: lostRequest, loading: lostLoading } = useApiRequest();
    const { request: scrapRequest, loading: scrapLoading } = useApiRequest();
    const { filters } = useSelector(({ inventory }) => ({
        filters: inventory.filters,
    }), shallowEqual);

    const { lists, loading, current, total, search, installerId, installer, type, typeId, installerList, discardData, selected } = state;

    const getPurchases = (pageIndex) => {
        let query = `?page=${pageIndex ? pageIndex : current}&limit=200`;
        if (search) query = `${query}&keyword=${search}`;
        if (installer) query = `${query}&installerId=${installerId}`;
        if (type) query = `${query}&inventoryTypeId=${typeId}`;

        setState(prev => ({ ...prev, loading: true }));
        getInstallerInventory(query).then(response => {
            const { data, meta } = response.data;
            setState(prev => ({ ...prev, lists: data ?? [], total: meta?.total ?? 1 }));
        }).catch(ex => { }).finally(() => setState(prev => ({ ...prev, loading: false })))
    }

    const paginationAction = (pageIndex) => {
        setState(prev => ({ ...prev, current: pageIndex }));
        getPurchases(pageIndex)
    }

    const onSelectHandler = (key, value) => {
        setState(prev => ({ ...prev, [key]: value?.name ?? "", [`${key}Id`]: value?.id ?? null }));
    }

    const getInstallerList = () => {
        getInstallers().then(response => {
            const { data } = response.data;
            if (isValidObject(data)) {
                setState(prev => ({ ...prev, installerList: formatListItems(data?.installers ?? [], "installerId", "name") }));
            }
        }).catch(ex => { });
    }

    const updateStatus = (data) => {
        const itemId = data?.inventorytypeid == 20 ? data?.gpsimei : data?.inventorytypeid == 21 ? data?.simimei : data?.gpsimei;
        const selType = filters?.allTransferType?.find((item) => item.name == data.type) || {};
        const payload = {
            transfer_type_id: selType?.id,
            inventory_state_id: selType?.allowed_states?.[0]?.inventory_state_id,
            inventory_type_id: data?.inventorytypeid,
            recipient_id: null,
            courier_details: null,
            item_ids: [itemId],
            remark: data?.remark ?? ""
        }
        const options = {
            method: "POST",
            url: appApis.inventoryTransfer,
            body: payload,
            onSuccess: () => {
                setState(prev => ({ ...prev, discardData: null }))
                paginationAction(1);
            }
        }
        if (data?.typeId == 27) lostRequest(options);
        else scrapRequest(options)
    }

    useEffect(() => {
        getInstallerList();
    }, [])

    useEffect(() => {
        paginationAction(1);
    }, [search, installer, type, current])

    return <div className="inventory-container purchase">
        {/* <SearchBox placeholder="Search here..." className="mb-3" value={search} onChange={(e) => setState(prev => ({ ...prev, search: e.target.value }))} /> */}
        <TableComponent col={4} breakPoint="lg" title={"Installer Inventory"} headers={headerColumn.installerInv} data={lists} current={current} total={total} tableLoading={loading} paginationAction={paginationAction} render={(tdData, index) => <tr onClick={() => setState(prev => ({ ...prev, selected: tdData }))} key={index}>
            <td>{(index ?? 0) + 1}</td>
            <td>{tdData?.installer_name ?? "-"}</td>
            <td>{tdData?.inventory_type ?? "-"}</td>
            <td>{tdData?.allocated ?? "-"}</td>
            <td>{tdData?.installed ?? "-"}</td>
            <td>{tdData?.remaining ?? "-"}</td>
            <td>{formatDate(tdData?.last_allocation_date ?? "")}</td>
            <td className="status"><span style={{
                backgroundColor: tdData?.status == "In Stock" ? "green" : tdData?.status == "Partial Stock" ? "orange" : "red"
            }}>{tdData?.status ?? "In Stock"}</span></td>
        </tr>} FilterComponent={<div className="d-flex justify-content-end">
            <div className="me-2">
                <SearchableDropdown
                    placeholder={"Installer Name"}
                    value={installer}
                    error={false}
                    options={installerList}
                    onSelect={(value) => onSelectHandler("installer", value)}
                />
            </div>
            <div className="me-2">
                <SearchableDropdown
                    placeholder={"Inventory Type"}
                    value={type}
                    error={false}
                    options={filters?.inventoryTypes ?? []}
                    onSelect={(value) => onSelectHandler("type", value)}
                />
            </div>
        </div>} />
        {selected ? <InventoryDetails show={isValidObject(selected)} inventory={selected} hideModal={() => setState(prev => ({ ...prev, selected: null}))} showReasonModal={(data) => setState(prev => ({ ...prev, selected:null, discardData: data }))} onSuccess={() => paginationAction(1)} /> : null}

        {discardData ? <ReasonModal show={discardData} title={discardData?.type == "Lost" ? "Lost Inventory" : "Scrap Inventory"} hideModal={() => setState(prev => ({ ...prev, discardData: null }))} submitAction={(remark) => updateStatus({ ...discardData, remark })} /> : null}
    </div>
}

export default InstallerInventory;